export const LANG_LT = `lt`;
export const LANG_RU = `ru`;
export const LANG_UK = `uk`;

export const POSSIBLE_SEARCH_LANGS = [LANG_LT, LANG_RU, LANG_UK];

export const TRANSLATIONS = {
  hit: {
    _template: {
      [LANG_LT]: ``,
      [LANG_RU]: ``,
      [LANG_UK]: ``,
    },
    address: {
      [LANG_LT]: `Adresas`,
      [LANG_RU]: `Aдрес`,
      [LANG_UK]: `Адреса`,
    },
    contacts: {
      [LANG_LT]: `Kontaktai`,
      [LANG_RU]: `Kонтакты`,
      [LANG_UK]: `Контакти`,
    },
    purpose: {
      [LANG_LT]: `Aprašymas`,
      [LANG_RU]: `Дополнительная информация`,
      [LANG_UK]: `Додаткова інформація`,
    },
    region: {
      [LANG_LT]: `Vieta`,
      [LANG_RU]: `Место нахождения`,
      [LANG_UK]: `Місцезнаходження`,
    },
    workingHours: {
      [LANG_LT]: `Darbo laikas`,
      [LANG_RU]: `Время работы`,
      [LANG_UK]: `Час роботи`,
    },
  },
  hitsPerPage: {
    [LANG_LT]: `puslapyje`,
    [LANG_RU]: `в страницу`,
    [LANG_UK]: `у сторінці`,
  },
  langSwitcher: {
    language: {
      [LANG_LT]: `Kalba`,
      [LANG_RU]: `Язык`,
      [LANG_UK]: `Мова`,
    },
  },
  refinements: {
    clearFilters: {
      [LANG_LT]: `Išvalyti filtrus`,
      [LANG_RU]: `Очистить фильтры`,
      [LANG_UK]: `Очистіть фільтри`,
    },
    languages: {
      [LANG_LT]: `Kalba`,
      [LANG_RU]: `Язык`,
      [LANG_UK]: `Мова`,
    },
    region: {
      [LANG_LT]: `Vieta`,
      [LANG_RU]: `Место нахождения`,
      [LANG_UK]: `Місцезнаходження`,
    },
    typeOfHelp: {
      [LANG_LT]: `Pagalbos rūšis`,
      [LANG_RU]: `Тип помощи`,
      [LANG_UK]: `Вид допомоги`,
    },
    panelTitle: {
      [LANG_LT]: `Filtrai`,
      [LANG_RU]: `Фильтры`,
      [LANG_UK]: `Фільтри`,
    },
    doFilter: {
      [LANG_LT]: `Filtruoti`,
      [LANG_RU]: `Фильтровать`,
      [LANG_UK]: `Фільтрувати`,
    },
  },
  searchBox: {
    [LANG_LT]: `Paieška`,
    [LANG_RU]: `Поиск`,
    [LANG_UK]: `Пошук`,
  },
  noResults: {
    [LANG_LT]: `Paieškai {query} rezultatų rasti nepavyko.`,
    [LANG_RU]: `По запросу {query} ничего не нашлось.`,
    [LANG_UK]: `Не знайдено результатів для {query}.`,
  },
};
